import { aboutSectionOverview } from "../../content/siteContent";
import { useSectionEntryStore } from "../../store/useSectionEntryStore";
import { ButtonLink } from "../ui/ButtonLink";

export function AboutSection() {
  const phase = useSectionEntryStore((state) => state.sections.about.phase);

  return (
    <section className="experience-section experience-section--about" data-entry-phase={phase}>
      <div className="about-page">
        <header className="about-page__hero">
          <div className="about-page__heroCopy">
            <p className="section-panel__eyebrow">{aboutSectionOverview.eyebrow}</p>
            <h2 className="section-panel__title section-panel__title--large about-page__heroTitle">
              {aboutSectionOverview.title}
            </h2>
            <p className="section-panel__lead about-page__heroLead">{aboutSectionOverview.intro}</p>
            <div className="about-page__heroActions">
              <ButtonLink to={aboutSectionOverview.ctaHref}>{aboutSectionOverview.ctaLabel}</ButtonLink>
            </div>
          </div>

          <div aria-hidden="true" className="about-page__heroStage">
            <div className="about-page__annotation">
              <span />
              <p>
                Narrative-led.
                <br />
                Culturally rooted.
              </p>
            </div>
          </div>
        </header>
      </div>
    </section>
  );
}
